import { NgModule } from "@angular/core";
import { DashboardComponent } from "./dashboard.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";

import { BrowserModule } from "@angular/platform-browser";
import { HomeComponent } from "./home/home.component";
import { SettingsComponent } from "./settings/settings.component";
import { AddComponent } from "./add/add.component";
import { RedCrossComponent } from "./red-cross/red-cross.component";
import { RefillsComponent } from "./refills/refills.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdminComponent } from "./admin/admin.component";
import { RefPaginatorComponent } from "./refills/paginator/ref-paginator.component";
import { TraPaginatorComponent } from "./travels/paginator/tra-paginator.component";
import { RefFilterComponent } from "./refills/filter/ref-filter.component";
import {
  TravelsComponent,
  ModalContentComponent,
} from "./travels/travels.component";
import { TraFilterComponent } from "./travels/filter/tra-filter.component";
import { RatingModule } from "ngx-bootstrap/rating";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PullToRefreshComponent } from "../../commons/pull-to-refresh/pull-to-refresh.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AssignCarToUserComponent } from "../../dialogs/assign-car-to-user/assign-car-to-user.component";
import { AssignUserToCarComponent } from "../../dialogs/assign-user-to-car/assign-user-to-car.component";
import { AssignAvailableCarToUserComponent } from "../../dialogs/assign-available-car-to-user/assign-available-car-to-user.component";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { BackofficeComponent } from "./backoffice/backoffice.component";
import { ChangeKmTravelComponent } from "../../dialogs/change-km-travel/change-km-travel.component";
import { ChangeRefillsComponent } from "../../dialogs/change-refills/change-refills.component";
import { CompileWarrantComponent } from "../../dialogs/compile-warrant/compile-warrant.component";
import { InsertRefillsComponent } from "../../dialogs/insert-refills/insert-refills.component";
import { EndTravelComponent } from "../../dialogs/end-travel/end-travel.component";
import { AdminAvailableVehiclesComponent } from "./admin-available-vehicles/admin-available-vehicles.component";
import { ChangeCarToUserComponent } from "../../dialogs/change-car-to-user/change-car-to-user.component";
import { FermiTecniciComponent } from "../../dialogs/fermi-tecnici/fermi-tecnici.component";
import { CreateFermoTecnicoComponent } from "../../dialogs/create-fermo-tecnico/create-fermo-tecnico.component";
import { SuperadminToolsComponent } from "./superadmin-tools/superadmin-tools.component";
import { CreateParkComponent } from "./superadmin-tools/create-park/create-park.component";
import { BrandsAndModelsComponent } from "./superadmin-tools/brands-and-models/brands-and-models.component";
import { ManageVehicleAuthComponent } from "./superadmin-tools/manage-vehicle-auth/manage-vehicle-auth.component";
import { ManageVehiclesComponent } from "./superadmin-tools/manage-vehicles/manage-vehicles.component";
import { VehicleSearchComponent } from "./superadmin-tools/vehicle-search/vehicle-search.component";
import { ManageRefuelsComponent } from "./superadmin-tools/manage-refuels/manage-refuels.component";
import { RouterModule } from "@angular/router";
import { ManageProfilesComponent } from "./superadmin-tools/manage-profiles/manage-profiles.component";
import { ManageTravelsComponent } from "./superadmin-tools/manage-travels/manage-travels.component";
import { NgxPaginationModule } from "ngx-pagination";
import { AdminChangeTravelsComponent } from "../../dialogs/admin-change-travels/admin-change-travels.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { EditVehicleModalComponent } from "../../dialogs/edit-vehicle-modal/edit-vehicle-modal.component";
import { EditBrandModalComponent } from "../../dialogs/edit-brand-modal/edit-brand-modal.component";
import { EditModelModalComponent } from "../../dialogs/edit-model-modal/edit-model-modal.component";
import { EditRefillModalComponent } from "../../dialogs/edit-refill-modal/edit-refill-modal.component";
import { ItinerarioComponent } from "../../components/itinerario/itinerario.component";

//? angular material modules
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import {
  MatPaginatorModule,
  MatPaginatorIntl,
} from "@angular/material/paginator";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatExpansionModule } from "@angular/material/expansion";

import { getItalianPaginatorIntl } from "../../commons/italian-paginator-intl";
import { RefreshCheckService } from "../../commons/refresh-superadmin-data.service";

import { dashboardRoutes } from "./dashboard.routes";

@NgModule({
  imports: [
    BrowserModule,
    FontAwesomeModule,
    ModalModule.forRoot(),
    ButtonsModule.forRoot(),
    PaginationModule.forRoot(),
    RatingModule.forRoot(),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatExpansionModule,
    FullCalendarModule,
    FormsModule,
    ReactiveFormsModule,
    NgxChartsModule,
    RouterModule,
    NgxPaginationModule,
    RouterModule.forChild(dashboardRoutes),
  ],
  exports: [],
  declarations: [
    DashboardComponent,
    HomeComponent,
    RefFilterComponent,
    TravelsComponent,
    PullToRefreshComponent,
    SettingsComponent,
    AddComponent,
    TraPaginatorComponent,
    TraFilterComponent,
    RedCrossComponent,
    RefillsComponent,
    AdminComponent,
    RefPaginatorComponent,
    AssignCarToUserComponent,
    AssignUserToCarComponent,
    AssignAvailableCarToUserComponent,
    BackofficeComponent,
    ChangeKmTravelComponent,
    CreateFermoTecnicoComponent,
    FermiTecniciComponent,
    ChangeRefillsComponent,
    CompileWarrantComponent,
    InsertRefillsComponent,
    EndTravelComponent,
    AdminAvailableVehiclesComponent,
    ChangeCarToUserComponent,
    ModalContentComponent,
    SuperadminToolsComponent,
    CreateParkComponent,
    BrandsAndModelsComponent,
    ManageVehicleAuthComponent,
    ManageVehiclesComponent,
    ManageProfilesComponent,
    ManageTravelsComponent,
    VehicleSearchComponent,
    ManageRefuelsComponent,
    AdminChangeTravelsComponent,
    EditVehicleModalComponent,
    EditBrandModalComponent,
    EditModelModalComponent,
    EditRefillModalComponent,
    ItinerarioComponent,
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: getItalianPaginatorIntl() },
    RefreshCheckService,
  ],
})
export class DashboardModule {}
